var _circle, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#42A460",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 22.5,
    width: 22.5,
    height: 18.75,
    rx: 2,
    stroke: "#42A460"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 26.5C18.75 24.6144 18.75 23.6716 19.3358 23.0858C19.9216 22.5 20.8644 22.5 22.75 22.5H37.25C39.1356 22.5 40.0784 22.5 40.6642 23.0858C41.25 23.6716 41.25 24.6144 41.25 26.5V27.5H18.75V26.5Z",
    fill: "#42A460"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 18.75L23.75 22.5",
    stroke: "#42A460",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 18.75L36.25 22.5",
    stroke: "#42A460",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenders);
export default __webpack_public_path__ + "static/media/calenders.1105704569eaa6a96be6f23b0789d034.svg";
export { ForwardRef as ReactComponent };